var App = App || {};

App.WebsiteFeedbackButton = (function ($) {
    'use strict';

    function init() {
        $('.feedback_btn').on('click', function () {
            var $popup = $('.feedback_popup');
            var $button = $(this);
            var isOpen = $popup.hasClass('open_popup');

            $popup.toggleClass('open_popup');

            // Update aria-expanded based on the toggle state
            $button.attr('aria-expanded', !isOpen);
        });

        $('.feedback_close').on('click', function () {
            $('.feedback_popup').toggleClass('open_popup');

            // Reset aria-expanded when the popup is closed
            $('.feedback_btn').attr('aria-expanded', 'false');
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.WebsiteFeedbackButton.init();
});
